import {
  combineTranslationBundles,
  loadPackageTranslations,
  Localization,
  setupTranslationLanguageSync,
  type LanguageCode
} from '@hconnect/common/localization-loaders'
import {uikitTranslations} from '@hconnect/uikit'
import i18n from 'i18next'

import {logger} from '../modules/common/utils/logger'

export const supportedLanguages: LanguageCode[] = [
  'en-US',
  'en-GB',
  'de-DE',
  'ru-RU',
  'it-IT',
  'fr-FR',
  'cs-CZ',
  'hu-HU',
  'nl-NL',
  'sv-SE',
  'es-ES',
  'ro-RO',
  'no-NO',
  'pl-PL'
]
const log = logger.context('localization', 'loader')

const isDevelopment = process.env.NODE_ENV === 'development'

const loader = async (filename: string): Promise<Record<string, unknown> | undefined> => {
  if (isDevelopment) {
    console.info(`Load Translation for plant settings app [${filename}]`)
  }
  try {
    return (await import(`./${filename}`)).default
  } catch (err) {
    if (isDevelopment) {
      console.error(`Could not load Translation for plant settings app [${filename}]`, err)
    }
    log.tags({filename, message: (err as Error)?.message}).error('Could not load translation')
    throw err
  }
}

const externalPackageTranslations = combineTranslationBundles([uikitTranslations])

export const initLocalization = () => {
  void Localization({
    fallbackLng: 'en-GB',
    compatibilityJSON: undefined,
    supportedLngs: [...supportedLanguages],
    backend: {
      loader
    },
    debug: isDevelopment,
    load: 'currentOnly'
  }).then(() => {
    void loadPackageTranslations(i18n, externalPackageTranslations, {debug: isDevelopment})
    setupTranslationLanguageSync(i18n, externalPackageTranslations, {debug: isDevelopment})
  })
}
